<template>
  <div>
    <catalog-select
      ref="catalog_select"
      catalog-name="вакансию"
      :is-disabled="isDisabled"
      :initial-value="value"
      :get-item-by-id="getVacancy"
      :get-list="getItems"
      :can-create-catalog="canEditVacancy()"
      @onSelect="$emit('onSelect', $event)"
      @open-modal="isModalVisible = true"
    />

    <vacancy
      v-if="isModalVisible"
      :exact-id="0"
      @modal-closed="isModalVisible = false"
      @refresh="onCatalogItemCreated"
    />
  </div>
</template>

<script>
import catalogs from "../../../network/catalogs";
  import permissions, {PERM} from "../../../utilites/permissions";
    import Vacancy from "./Vacancy.vue";
    import CatalogSelect from "../CatalogSelect.vue";

export default {
  name: "VacancySelect",
  components: {CatalogSelect, Vacancy },
  mixins: [
    catalogs,
    permissions,
  ],
  props: {
    isDisabled: { type: Boolean, default: null },
    value: { type: Number, default: null },
  },
  data() {
    return {
      isModalVisible: false
    }
  },
  methods: {
    async getItems() {
      const result = await this.getVacancySearch('');
      return (result && result.data) ? result.data : [];
    },
    async getVacancy(id) {
      const result = await this.getVacancyById(id);
      return (result && result.data) ? result.data : null;
    },
    async onCatalogItemCreated(newItem) {
      this.$refs.catalog_select.onItemCreated(newItem);
      this.isModalVisible = false;
    },
    // Permissions
    canEditVacancy() {
      return this.hasPermission([PERM.CATALOG_VACANCY_EDIT]);
    }
  },
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Catalogs/Vacancies/VacancySelect.vue